import Query from './utils/query';
import Formatting from './utils/formatting';
import isEmail from './utils/email';
import isNip from './utils/nip';
import isNoDeadline from './utils/isNoDeadline';
import isBetween from './utils/isBetween';

export * from './utils/get-tel-href';
export { Query, Formatting, isEmail, isNip, isNoDeadline, isBetween };
